import { Component, OnInit } from '@angular/core';
import { QuestionService } from 'src/app/service/question.service';


@Component({
  selector: 'app-survay-header',
  templateUrl: './survay-header.component.html',
  styleUrls: ['./survay-header.component.scss']
})
export class SurvayHeaderComponent implements OnInit {
  public headerLogoImg:any;
  // public this.qSerive.screenTemplateDetails:any = {};


  constructor(
    public qSerive:QuestionService
  ) { }

  ngOnInit(): void {
    // setTimeout(() =>{
    //   this.this.qSerive.screenTemplateDetails = this.qSerive.screenTemplateDetails;
    // },200)
  }

  redirectBackUrl(){
    if(this.qSerive.screenTemplateDetails && this.qSerive.screenTemplateDetails['isBack'] && this.qSerive.screenTemplateDetails['backurl']){
      window.location.href = this.qSerive.screenTemplateDetails['backurl'];
    }
  }

}
